import React, { useEffect, useState } from 'react';
import Location from './Location';
import useApiGetWithToken from '../../../DataServices/useApiGetWithToken';
import LoadingIndicator from '../../../Layout/LoadingIndicator';
import AddRetail from './AddRetail';
import postApiWithToken from '../../../DataServices/postApiWithToken';
import { Link, useHistory } from 'react-router-dom';

import TagManager from 'react-gtm-module';
// Setting up GTM for My retail page.
const tagManagerArgs = {
    dataLayer: {
      page: 'my-retail',
      event:'spa-pageview'
  }
}

// Main container for the My Retail page.
const MyRetail = (props) => {
  const [initialLocations, setInitialLocations] = useState([]);
  const [locations, setLocations] = useState([]);
  const [primary, setPrimary] = useState();
  const [deletedLocations, setDeletedLocations] = useState([]);
  const [addedLocations, setAddedLocations] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [editable, setEditable] = useState();
  const [loading, setIsLoading] = useState(false);
  const [addAnother, setAddAnother] = useState(false);
  const history = useHistory();
  props.setPage('my-retail');

  useEffect(() =>{
    TagManager.dataLayer(tagManagerArgs)
  }, [])

  // Holds list of locations associated with customer account.
  let displayLocations = '';

  // Retrieve locations associated with the account. 
  // Requires customer sub (ADB@C id) as param.
  const { data, error, isLoaded, triggerFetch } = useApiGetWithToken("/customerRetail/"+props.customer.sub );
  useEffect(() => {
    setLocations(data);
    setInitialLocations(data);
    setPrimary(data.filter(loc => loc.isPrimary === true)[0]?.retailID);
  }, [data]);

  // Save locations function.
  useEffect(() => {
    if (loading) {
      (async() => {
        // Check if user is adding location and save the new location.
        if (addedLocations.length > 0) {
          const addlUpdate = {
            "sub":props.customer.sub,
            "locations": addedLocations
          }
          await postApiWithToken(
            props.authProps.account, 
            props.authProps.instance, 
            props.authProps.inProgress, 
            '/customerRetail/', 
            addlUpdate);
        }
        // Retrive updates from the list of locations. 
        // This can be adding membership number or chaging the primary location.
        var l = locations;
        var u = []
        l.forEach(
          function(val) {
            if (val.hasOwnProperty("method")) {
              var loc = {"retailId":val.retailID, "isPrimary":val.isPrimary, "membershipNumber":val.membershipNumber, "method":val.method}
              u = u.concat(loc);
            }
          }
        )
        if (u.length > 0 || deletedLocations.length > 0) {
          const updates = u.concat(deletedLocations)
          const retailUpdate = {
            "sub":props.customer.sub,
            "locations": updates
          }
          await postApiWithToken(
            props.authProps.account, 
            props.authProps.instance, 
            props.authProps.inProgress, 
            '/customerRetail/', 
            retailUpdate);
        }
          // once the changes are made go back to main page.
          clearStates();
          props.setPage('home')
          history.push("/")

      })()
    }

  }, [loading])

  // Resetting all states.
  const clearStates= () => {
    setDeletedLocations([])
    setAddedLocations([])
    setLocations([])
    setIsDisabled(true)
    setEditable()
    setIsLoading(false)
  }

  // Logic to switch primary location assignment.
  // Locate the previous primary and reset.
  // Preserve the rest of the parameters.
  const changePrimary = (e) => {
    var locs = [...locations];
    locs = locs.map(p =>
      p.retailID === primary
        ? { ...p, isPrimary: false, method: 'update' }
        : p
    ).map(p =>
      p.retailID === e.target.value
        ? { ...p, isPrimary: true, method: 'update' }
        : p
    );
    setPrimary(e.target.value)
    setLocations(locs)
    setIsDisabled(false);
  }

  // Update membership number.
  const changeMembershipNumber = (id, mn) => {
    var locs = [...locations];
    locs = locs.map(p =>
      p.retailID === id
        ? { ...p, membershipNumber: mn, method: 'update' }
        : p
    )
    setLocations(locs)
    setIsDisabled(false)
  }

  // Trigger save functionality.
  const saveLocations = () => {
    setIsLoading(true) 
  };

  // Add new reatil functionality. 
  // Executed from inside of the AddRetail component.
  const addRetail = (retail) => {
    if (retail[0].isPrimary) {
      const oldPrimary = data.filter(loc => loc.isPrimary === true)[0]
      retail.unshift({
        "retailId" : oldPrimary.retailID, 
        "isPrimary":false, 
        "membershipNumber":oldPrimary.membershipNumber, 
        "method": "update"
      })
    }
    setAddedLocations(retail)
    setIsLoading(true)
  }

  // Toggles location card view and makes it editable.
  const selectLocation = (id) => {
    if (id === editable) {
      setEditable()
    } else {
      setEditable(id)
    }
  }

  // Handles location removal. Removed location is unset formt the list of customer locations.
  // Removal is not saved until the Save button is pressed and the form is submitted.
  const removeLocation = (id) => {
    // remove location from list of locations.
    var newLocations = locations.filter(loc => loc.retailID !== id);
    // Was this location added in this section. If yes remove it.
    var a = addedLocations;
    if (a.filter(loc => loc.retailId === id).length > 0) {
      var al = a.filter(loc => loc.retailId !== id);
      setAddedLocations(al)
    }
    else {
      var loc = {"retailId" : id, "isPrimary":false, "method": "delete"};
      setDeletedLocations(deletedLocations.concat(loc))
    }
    setLocations(newLocations);
    setIsDisabled(false);
  }

  if (error !== null) {
    return <div>Error: {error.message}</div>;
  }
  // Enables Loader overlay when locations are retried or saved.
  if (!isLoaded || loading) {
    return <LoadingIndicator />;
  }

  // When the state addAnother is set to true the component will render 
  // AddRetail component instead.
  if (addAnother) {
    return (
      <AddRetail 
        primary={primary}
        customer={props.customer}
        setAddAnother={setAddAnother}
        addRetail={addRetail}
        existingLocations={initialLocations}
      />
    )
  }

  // Mapping the list of returned locations to the Location component.
  if (locations.length > 0) {
    displayLocations = locations.map((location) =>
      <Location 
        action='edit'  
        key={location.retailID} 
        location={location}
        remove={removeLocation}
        changePrimary={changePrimary}
        selectLocation={selectLocation}
        editable={editable}
        changeMembershipNumber={changeMembershipNumber}
        />
    );
  }

  return (
      <div className="my-details">
        <h2>My Co-ops</h2>
        <form>
          <div className='profile-form'>
            {displayLocations}
          </div>

          <div className="buttons">
            <button 
              type="button" 
              className="cancel btn secondary" 
              onClick={()=>setAddAnother(true)} 
              aria-label="Add Another"
            >+ Add Another</button>
          </div>
          <div className="buttons">
            <button 
              type="button" 
              className="save btn primary" 
              onClick={()=>saveLocations()} 
              disabled={isDisabled} 
              aria-label="Save"
            >Save</button>
            <Link 
              type="button" 
              className="cancel btn secondary" 
              onClick={()=>props.setPage('home')} 
              to={'/'}
              aria-label="Cancel"
            >Cancel</Link>
          </div>

        </form>
      </div>

    );
}

export default MyRetail;